import React, { useState } from 'react'
import { Button } from 'lib/ui/components'
import { useStoreView } from 'hooks/useStoreView'
import { CheckoutButton, LivbriteButton, ModalFooter, ModalContent } from './components/Styled'
import { useCartContextProvider } from 'components/Cart/components/CartProvider'
import { Modal } from 'components/Modal'

export const Actions = () => {
  const [openModal, setOpenModal] = useState(false)
  const { isLivBrite } = useStoreView()
  const { shouldWarning } = useCartContextProvider()
  function goToCheckout () {
    window.location.href = '/checkout'
  }

  const handleClick = () => {
    if (shouldWarning) {
      setOpenModal(true)
    } else {
      goToCheckout()
    }
  }

  const ButtonWrapper = isLivBrite ? LivbriteButton : CheckoutButton

  return (
    <>
      <ButtonWrapper>
        <Button
          onClick={handleClick}
        >
          Proceed to Checkout
        </Button>
      </ButtonWrapper>
      <Modal
        isOpen={openModal}
        modalTitle='Review your Cart Changes'
        handleCloseModal={() => setOpenModal(false)}
        type='normal'
        footer={
          <ModalFooter>
            <Button onClick={() => setOpenModal(false)}>
              Close
            </Button>
            <Button
              onClick={goToCheckout}
            >
              Proceed to Checkout without saving
            </Button>
          </ModalFooter>
        }
      >
        <ModalContent>
          <h1>
            Wait - you have unsaved changes!
          </h1>
          <h3>
            Please save the item updates for your changes to be reflected
          </h3>
        </ModalContent>
      </Modal>
    </>
  )
}
